<template>
  <div>
    <van-popup
      v-model="show"
      round
      position="bottom"
      class="my-popup"
      @close="bindClose"
    >
      <div class="toast-container" v-if="activityInfo && userInfo">
        <div class="toast-top">
          <van-tabs v-model="active" class="nav-container">
            <van-tab
              :title="item.name"
              v-for="(item, index) in navList"
              :key="index"
            ></van-tab>
          </van-tabs>
          <div class="tips">每日早上7点更新每日任务</div>
        </div>
        <div class="v-info">
          <div class="v-text"
            ><span>拥有投票券：</span
            ><span class="v-num">{{ userInfo.user_vote_num }}张</span></div
          >
          <div class="v-desc">投票券将在{{ endTime }}清空</div>
        </div>
        <div class="nav-wrapper">
          <div class="nav-scroll" v-show="active == 0">
            <div class="task-list">
              <div
                class="task-item"
                :class="{ 'task-item-confirm': item.plan_state }"
                v-for="(item, index) in taskList"
                :key="index"
              >
                <img class="task-item-icon" :src="item.icon" />
                <div class="task-item-center">
                  <div class="task-item-title">{{ item.name }}</div>
                  <div class="task-item-desc">{{ item.notice }}</div>
                </div>
                <div class="task-item-dash">
                  <div
                    class="dash-item"
                    v-for="(item, index) in 6"
                    :key="index"
                  ></div>
                </div>
                <div class="task-item-num">+{{ item.reward_num }}票</div>
                <div class="task-item-btn" @click="bindClickTaskBtn(item)">{{
                  item.plan_state ? '已完成' : item.button_content || '去完成'
                }}</div>
              </div>
            </div>
          </div>
          <div class="nav-scroll" v-show="active == 1">
            <div class="invite-content">
              <div class="invite-title">邀请好友注册下载</div>
              <div class="invite-desc"
                >好友通过你分享的二维码注册betterWE账号<br />并且下载app登录才算邀请成功</div
              >
              <div class="invite-btn" @click="bindInviteFriend"
                ><span>邀请好友</span
                ><span class="invite-unit">（+5票/人）</span></div
              >
              <div class="invite-history">
                <div class="invite-num"
                  >邀请历史（{{ inviteList.length }}人）</div
                >
                <div class="invite-list">
                  <div
                    class="invite-item"
                    v-for="(item, index) in inviteList"
                    :key="index"
                  >
                    <!--     <div class="i-name">{{ item.nickname }}</div> -->
                    <div class="i-phone">{{ item.phone }}</div>
                    <div class="i-dash"></div>
                    <div class="i-time">{{ item.created_at }}</div>
                  </div>
                  <div class="not-data" v-if="!inviteList.length"
                    >暂无邀请记录</div
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    voteNum: {
      type: Number,
      default: 0
    },
    value: {
      type: Boolean,
      default: false
    },
    activityInfo: {
      type: Object,
      default: null
    },
    userInfo: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    activityId: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      show: false,
      active: 0,
      navList: [
        {
          name: '任务中心'
        },
        {
          name: '邀请好友'
        }
      ],
      taskList: [],
      inviteList: []
    }
  },
  computed: {
    endTime() {
      if (this.activityInfo) {
        let endTime = this.activityInfo.activityInfo.end_time.replace(/-/g, '/')
        let time = new Date(endTime)
        let month = time.getMonth() + 1
        let day = time.getDate()
        let hours = time.getHours()
        return month + '月' + day + '日' + hours + '时'
      }
      return ''
    }
  },
  watch: {
    value() {
      this.show = this.value
      if (this.value) {
        this.getInviteList()
        this.getTaskList()
      }
    },
    index() {
      this.active = this.index
    }
  },
  created() {
    this.show = this.value
    this.active = this.index
    // this.getInviteList();
    //this.getTaskList();
  },
  methods: {
    bindClose() {
      this.$emit('input', false)
    },
    bindInviteFriend() {
      if (!this.checkActivity()) {
        return
      }
      this.$emit('invite')
    },
    //检查活动时间
    checkActivity() {
      if (this.activityInfo.activityInfo.activity_state == 2) {
        this.$toast('活动未开始')
        return false
      } else if (this.activityInfo.activityInfo.activity_state == 3) {
        this.$toast('活动已结束')
        return false
      }
      return true
    },
    bindClickTaskBtn(item) {
      if (!this.checkActivity()) {
        return
      }
      /* 如果任务锁定了 */
      if (item.is_lock) {
        let relateTask = this.taskList.find((item1) => {
          return item1.id == item.relate_plan_id
        })
        if (relateTask) {
          this.$toast('请先完成第一个任务“' + relateTask.name + '”')
        } else {
          this.$toast('前置解锁任务不存在')
        }
        return
      }
      if (!item.plan_state) {
        //未完成
        switch (item.complete_type) {
          case 1:
            /* 点击即可完成 */
            this.completeTask(item.plan_id)
            this.$betterwe.jumpRoute(item.jump_url)
            break
          case 2:
            this.$betterwe.jumpRoute(item.jump_url)
            break
        }
      }
    },
    async completeTask(id) {
      let res = await this.$http
        .postApp('api/v1/Vote/completePlan', {
          plan_id: id,
          activity_id: this.activityId
        })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.getTaskList()
          this.$emit('complete')
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getInviteList() {
      this.loading = true
      let res = await this.$http
        .getApp('api/v1/Vote/inviteUserRecord', {
          activity_id: this.activityId
        })
        .catch(() => {
          this.loading = false
        })
      if (res) {
        this.loading = false
        res = res.data
        if (res.code == 200) {
          this.inviteList = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getTaskList() {
      this.loading = true
      let res = await this.$http
        .getApp('api/v1/Vote/getVotePlanList', { activity_id: this.activityId })
        .catch(() => {
          this.loading = false
        })
      if (res) {
        this.loading = false
        res = res.data
        if (res.code == 200) {
          this.taskList = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.my-popup {
  height: 460px;
}

.toast-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0px 20px;

  .toast-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;

    .nav-container {
      width: 170px;

      ::v-deep .van-tab {
        font-size: 16px;
      }

      ::v-deep .van-tab--active {
        font-weight: bold;
      }

      ::v-deep .van-tabs__line {
        width: 15px;
        height: 3px;
        background: #9071ff;
        border-radius: 2px;
        bottom: 20px;
      }
    }

    .tips {
      margin-left: 20px;
      font-size: 11px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 16px;
    }
  }

  .v-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f7f7f7;
    border-radius: 4px;
    height: 28px;
    padding: 0px 12px;
    margin-bottom: 16px;

    .v-text {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;

      .v-num {
        color: rgba(98, 54, 255, 1);
      }
    }

    .v-desc {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 20px;
    }
  }

  .nav-wrapper {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    @include paddingBottom(0px);

    .nav-scroll {
      height: 100%;
      overflow-y: scroll;
    }
  }

  .task-list {
    @include paddingBottom(10px);

    .task-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .task-item-icon {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }

      .task-item-center {
        position: relative;
        padding-right: 9px;

        .task-item-title {
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
        }

        .task-item-desc {
          font-size: 10px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 20px;
        }
      }

      .task-item-dash {
        width: 1px;
        height: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .dash-item {
          width: 1px;
          height: 1px;
          background-color: #979797;
        }
      }

      .task-item-num {
        margin: 0 9px;
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 20px;
      }

      .task-item-btn {
        width: 72px;
        height: 30px;
        box-sizing: border-box;
        text-align: center;
        background: #ffffff;
        border-radius: 15px;
        border: 2px solid rgba(116, 95, 255, 1);
        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #6236ff;
        line-height: 26px;
      }
    }

    .task-item:last-child {
      margin-bottom: 0;
    }

    .task-item-confirm {
      .task-item-num {
        font-weight: bold;
      }

      .task-item-btn {
        background: #f1f1f1;
        color: rgba(0, 0, 0, 0.3);
        border: none;
      }
    }
  }

  .invite-content {
    text-align: center;

    .invite-title {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin-bottom: 6px;
    }

    .invite-desc {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 20px;
      margin-bottom: 11px;
    }

    .invite-btn {
      margin-bottom: 24px;
      height: 40px;
      background: linear-gradient(90deg, #c592ff 0%, #6c5aff 100%);
      border-radius: 24px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #ffffff;
      line-height: 40px;

      .invite-unit {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #ffffff;
      }
    }

    .invite-history {
      .invite-num {
        padding: 0 13px;
        text-align: left;
        height: 28px;
        line-height: 28px;
        background: #f7f7f7;
        border-radius: 4px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
        margin-bottom: 12px;
      }

      .invite-list {
        padding: 0px 16px 30px;

        .invite-item {
          display: flex;
          align-items: center;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;

          .i-name {
            font-weight: bold;
            color: rgba(0, 0, 0, 0.8);
            margin-right: 8px;
          }

          .i-dash {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            height: 0;
            border-bottom: 1px dashed #979797;
            margin: 0 6px;
          }

          .i-time {
            width: 130px;
            text-align: left;
          }
        }

        .not-data {
          text-align: center;
          margin-top: 50px;
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
}
</style>
